import { gql } from '@apollo/client';
import { categoryFragment } from '../fragments/category';
import { goalFragment } from '../fragments/goal';
import { questFragment } from '../fragments/quest';

export const getSingleQuestQuery = gql`
    ${categoryFragment}
    ${goalFragment}
    ${questFragment}

    query GetSingleQuest($id: String!) {
        quest(id: $id) {
            ...QuestFields
            category {
                ...CategoryFields
            }
            goal {
                ...GoalFields
                category {
                    ...CategoryFields
                }
            }
        }
    }
`;
